import React, { useMemo } from 'react';

import { Typography } from 'antd';

import MaskedOutput from 'components/MaskedOutput';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import type { ICDFList } from 'v2/services/cdfService/types';

interface IProps {
  data: ICDFList[0]['list'][0]['customer_origin'] | ICDFList[0]['list'][0]['destination_customer'];
}

const cleanupCaracteres = (value: string) => {
  return value.replace(/(^[,-\s]+|[-,\s]+$|\s{2,}|\n)/gi, ' ').trim();
};

const Customer: React.FC<IProps> = ({ data }) => {
  const address = useMemo(() => {
    return cleanupCaracteres(
      !data.address
        ? ''
        : `${data.address.street || ''}, ${data.address.number || ''} ${data.address.complement || ''} - ${data.address.neighborhood || ''}`
    );
  }, [data.address]);

  const cityState = useMemo(() => {
    return cleanupCaracteres(!data.address ? '' : `${data.address.city || ''}/${data.address.state || ''}`);
  }, [data.address]);

  const phones = useMemo(() => {
    return cleanupCaracteres(`${data.phone || ''}/${data.cellphone || ''}`);
  }, [data.phone, data.cellphone]);

  return (
    <div>
      <Typography.Text>
        <strong>Razão Social: </strong>
        {data.name}
      </Typography.Text>
      <br />
      <Typography.Text>
        <strong>CNPJ/CPF: </strong>
        <MaskedOutput mask='cpfCnpj' value={data.document_number} />
      </Typography.Text>
      <br />
      <Typography.Text>
        <strong>IE: </strong>
        <PermissionHide action='myeduzz:cdf:ver-dados-clientes' fallback={<em>oculto</em>}>
          {data.state_register}
        </PermissionHide>
      </Typography.Text>
      <br />
      <Typography.Text>
        <strong>IM: </strong>
        <PermissionHide action='myeduzz:cdf:ver-dados-clientes' fallback={<em>oculto</em>}>
          {data.municipal_register || '-'}
        </PermissionHide>
      </Typography.Text>
      <br />
      <Typography.Text>
        <strong>E-mail: </strong>
        <PermissionHide action='myeduzz:cdf:ver-dados-clientes' fallback={<em>oculto</em>}>
          {data.email}
        </PermissionHide>
      </Typography.Text>
      <br />
      <Typography.Text>
        <strong>Endereço: </strong>
        <PermissionHide action='myeduzz:cdf:ver-dados-clientes' fallback={<em>oculto</em>}>
          {address}
        </PermissionHide>
      </Typography.Text>
      <br />
      <Typography.Text>
        <strong>Cidade/UF: </strong>
        <PermissionHide action='myeduzz:cdf:ver-dados-clientes' fallback={<em>oculto</em>}>
          {cityState}
        </PermissionHide>
      </Typography.Text>
      <br />
      <Typography.Text>
        <strong>Telefones: </strong>
        <PermissionHide action='myeduzz:cdf:ver-dados-clientes' fallback={<em>oculto</em>}>
          {phones}
        </PermissionHide>
      </Typography.Text>
    </div>
  );
};

export default Customer;
